import { useEffect, useState } from 'react';

import pkg from '../../package.json';

const pkgVersion = pkg.version;

async function getVersion() {
  // 开发环境直接返回当前版本
  if (process.env.NODE_ENV === 'development') {
    return pkgVersion;
  }

  const res = await fetch(`/version.txt?_t=${Date.now()}`);

  // 版本获取失败时，返回当前版本
  if (!res.ok) {
    return pkg.version;
  }

  const text = await res.text();

  return text.trim();
}

/**
 * 检查版本是否发生变化，如果发生变化，那么重新加载页面
 *
 * @returns {boolean} isReloading 是否正在重新加载页面
 */
export function useShouldReload() {
  const [isReloading, setIsReloading] = useState(true);
  // 如果正在获取版本信息或者应该重新加载页面，那么 isReloading 为 true

  useEffect(() => {
    async function loadData() {
      try {
        const version = await getVersion();

        if (version !== pkgVersion) {
          window.location.reload();
        } else {
          setIsReloading(false);
        }
      } catch (error) {
        setIsReloading(false);
      }
    }

    loadData();
  }, []);

  return { isReloading };
}
